<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-row>
        <v-col>
          <span>
            {{ title }}
          </span>
        </v-col>
        <v-col cols="auto">
          <BaseDialogActions hideRefresh hideFullscreen />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pt-5">
      <v-row dense v-for="item in content" :key="item.field">
        <v-col cols="12" sm="5">{{ item.label }}:</v-col>
        <v-col cols="12" sm="7" class="d-flex justify-end">{{ item.value }}</v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>

    </v-card-actions>
  </v-card>
</template>

<script>
import { utcToLocalDate } from '@/utils/DateFormatter.js'
import { poundsToTons } from '@/utils/NumericMutations'

export default {
  name: 'ExpansionDetails',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    expansion: {
      type: Object,
      required: true
    }
  },

  computed: {
    title () {
      return this.$t('expansion')
    },

    content () {
      return [
        {
          field: 'establishedOn',
          label: this.$t('establishedOn'),
          value: utcToLocalDate(this.expansion.establishedOn)
        },
        {
          field: 'expiredOn',
          label: this.$t('expiredOn'),
          value: utcToLocalDate(this.expansion.expiredOn)
        },
        {
          field: 'sampleSize',
          label: this.$t('sampleSize'),
          value: this.expansion.sampleSize
        },
        {
          field: 'pieces',
          label: this.$t('averagePieces'),
          value: this.expansion.pieces
        },
        {
          field: 'averageSED',
          label: this.$t('averageSED'),
          value: this.expansion.averageSED
        },
        {
          field: 'netWeight',
          label: this.$t('netWeight'),
          value: poundsToTons(this.expansion.inWeight - this.expansion.outWeight - this.expansion.defectWeight)
        },
        {
          field: 'grossWeight',
          label: this.$t('grossWeight'),
          value: poundsToTons(this.expansion.inWeight)
        }
      ]
    }
  },

  methods: {
    utcToLocalDate
  }
}
</script>
